import { readonly } from "vue"

export const CHANNEL_SCOPE = {
    MEMBERS_ONLY_FREE: 'members_free',
    MEMBERS_ONLY_PAID: 'members_paid',
    BIGNERVE_SUBSCRIBERS: 'bignerve_subscribers',
    MINIMUM_COMMENTATOR_SCORE: 'minimum_commentator_score',
}

export const CHANNEL_MODE = {
    PRIVATE: 'private',
    PUBLIC: 'public'
}

export const ACCESS_LEVEL = {
    WRITE: 'write',
    READONLY: 'readonly',
}